/* eslint-disable no-unused-expressions */
/* 左边的品牌列表 */
import React, { useRef, useState, useEffect, useCallback } from 'react'
import classnames from 'classnames'
import { sendTeaCommEvent } from 'lib/tea-analyze'

interface Options {
  param: any
  text: string
  key: string
}

interface IProps {
  value?: string[]
  options: Options[]
  name?: string
  onChange?: (value: string[]) => void
}

const DEFAULT_VALUE: string[] = []

export default function MultipleList({
  options,
  name,
  value = DEFAULT_VALUE,
  onChange,
}: IProps) {
  const [current, setCurrent] = useState<string[]>(value)

  useEffect(() => {
    setCurrent(value)
  }, [value])

  function isAll() {
    const { length } = options
    for (let i = 0; i < length; i++) {
      const item = options[i]
      // 空字符串为 不限
      if (item.key && !isActive(item.key)) {
        return false
      }
    }
    return true
  }

  function isActive(key: string) {
    if (current?.indexOf(key) > -1) {
      return true
    }
    return false
  }

  const setCurrentProxy = useCallback(
    (key: string) => {
      let tmp = [...current]
      if (key) {
        if (tmp?.length) {
          const index = tmp.indexOf(key)
          if (index > -1) {
            // 删除
            tmp.splice(index, 1)
          } else {
            tmp.push(key)
          }
        } else {
          tmp.push(key)
        }
      } else {
        // 空 为点击了不限 全选或者晴空所有
        if (isAll()) {
          tmp = []
        } else {
          tmp = options.map((item: Options) => item.key)
        }
      }
      onChange?.(tmp)
      setCurrent(tmp)
    },
    [current, setCurrent, onChange]
  )

  return (
    <div className="multiple-list-wrap">
      {options.map((item: Options, index: number) => {
        return (
          <p
            className={classnames('multiple-child', {
              selected: item.key ? isActive(item.key) : isAll(),
            })}
            onClick={(event) => {
              event.stopPropagation()
              setCurrentProxy(item.key)
              if (!(item.key ? isActive(item.key) : isAll())) {
                sendTeaCommEvent('clk_event', {
                  event_id: 'car_select_other_category',
                  car_category_name: name,
                  car_category_value: item.text,
                })
              }
            }}
            key={`multiple-child-${index}`}
          >
            <span className="icon" />
            {item.text}
          </p>
        )
      })}
      <style jsx>
        {`
          .multiple-list-wrap {
            width: 160px;
            text-align: left;
            padding: 10px 0 5px 0;
            box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08);
            background-color: #ffffff;
            z-index: 100;
          }
          .multiple-child {
            padding: 8px 20px;
            cursor: pointer;
          }
          .multiple-child:hover {
            background-color: #f7f8fc;
          }
          .icon {
            display: inline-block;
            width: 20px;
            height: 20px;
            vertical-align: middle;
            margin-right: 4px;
            margin-top: -5px;
            background: url(${require('./static/checkbox.png')}) no-repeat 0 0 /
              cover;
          }
          .selected .icon {
            background: url(${require('./static/checkbox-active.png')})
              no-repeat 0 0 / cover;
          }
        `}
      </style>
    </div>
  )
}
